import moment from 'moment';
import React, { useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { sess_get } from 'utils/HttpRequests';

export default function Main() {
  const [error, setError] = useState('');
  const [data, setData] = useState([]);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [status, setStatus] = useState('');
  const [identifier, setIdentifier] = useState('');
  const [userType, setUserType] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [loading, setLoading] = useState(false);
  const csvLink = useRef(null);

  const fetchData = () => {
    setLoading(true);
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    const val = {
      from, to, status, identifier, sort_by: sortBy, userType,
    };
    if (val.sort_by === 'renewal') {
      delete val.identifier;
      delete val.userType;
      delete val.status;
    }
    if (status === 'All') delete val.status;
    setLoading(true);
    sess_get('admin/console/report', session_token, val)
      .then((res) => {
        setData(res?.data?.response);
        setError('');
        setLoading(false);
        csvLink.current.link.click();
      })
      .catch((err) => {
        setError(err?.response?.data?.error?.reason);
        setLoading(false);
      });
  };

  let identifierTitle = '';
  if (identifier === 'v_mobile_no') identifierTitle = 'Doosra Number';
  if (identifier === 'zvr_mobile_no') identifierTitle = 'Mobile Number';
  if (identifier === 'user_id') identifierTitle = 'User ID';

  return (
    <div>
      <div
        style={{
          backgroundColor: 'aliceblue',
          border: '1px solid black',
          padding: '20px',
          width: 'fit-content',
          margin: '50px auto',
          borderRadius: '6px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '240px',
            margin: '10px',
          }}
        >
          <label style={{ color: '#666666', margin: 0 }}>Identifier</label>
          <select
            onChange={(e) => setIdentifier(e.target.value)}
            value={identifier}
          >
            <option value="" selected disabled hidden>--- select option ---</option>
            <option value="user_id">User ID</option>
            <option value="zvr_mobile_no">Mobile Number</option>
            <option value="v_mobile_no">Doosra Number</option>
            <option value="zvr_email">Email</option>
          </select>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '240px',
            margin: '10px',
          }}
        >
          <label style={{ color: '#666666', margin: 0 }}>User Type</label>
          <select
            disabled={sortBy === 'renewals'}
            onChange={(e) => setUserType(e.target.value)}
            value={userType}
          >
            <option value="" selected disabled hidden>--- select option ---</option>
            <option value="PRO">Pro</option>
            <option value="ESSENTIAL">Essential</option>
          </select>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '240px',
            margin: '10px',
          }}
        >
          <label style={{ color: '#666666', margin: 0 }}>Status</label>
          <select
            disabled={sortBy === 'renewals' || sortBy === 'deleted_at'}
            onChange={(e) => setStatus(e.target.value)} value={status}>
            <option>All</option>
            <option value="ACTIVE">Active</option>
            <option value="EXPIRED">Expired</option>
            <option value="FREE_TRIAL">Free Trial</option>
            <option value="DROPPED_OFF">Dropped Off</option>
            <option value="TERMINATED">Terminated</option>
            <option value="DELETED">Deleted</option>
            <option value="SUSPENDED">Suspended</option>
            <option value="DELETED_ACCOUNT">Deleted Account</option>
          </select>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '240px',
            margin: '10px',
          }}
        >
          <label style={{ color: '#666666', margin: 0 }}>Sort by</label>
          <select onChange={(e) => setSortBy(e.target.value)} value={sortBy}>
            <option value="" selected disabled hidden>--- select option ---</option>
            <option value="created_at">Joining Date</option>
            <option value="expire_on">Expiry Date</option>
            <option value="initial_activated_at">
              Activation Date
            </option>
            <option value="terminated_at">
              Termination Date
            </option>
            <option value="kyc_date">
              KYC verification date
            </option>
            <option value="renewals">Renewals</option>
            <option value="deleted_at" disabled={status !== 'DELETED_ACCOUNT'}>Deleted Date</option>
          </select>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '240px',
            margin: '10px',
          }}
        >
          <label style={{ color: '#666666', margin: 0 }}>From</label>
          <input
            type="date"
            onChange={(e) => {
              setFrom(e.target.value);
            }}
            value={from}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '240px',
            margin: '10px',
          }}
        >
          <label style={{ color: '#666666', margin: 0 }}>To</label>
          <input
            type="date"
            onChange={(e) => {
              setTo(e.target.value);
            }}
            value={to}
          />
        </div>
        <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
        <div
          style={{
            textAlign: 'right',
            margin: '20px 10px',
          }}
        >
          {
            loading ? (
              <button
                style={{
                  color: 'white',
                  backgroundColor: 'black',
                  fontSize: '18px',
                  padding: '4px 10px',
                  border: 'none',
                  borderRadius: '4px',
                }}
              >
                Please wait ...
              </button>
            ) : (
              <button
                style={{
                  color: 'white',
                  backgroundColor: 'black',
                  fontSize: '18px',
                  padding: '4px 10px',
                  border: 'none',
                  borderRadius: '4px',
                }}
                onClick={fetchData}
              >
                Download
              </button>
            )
          }
        </div>

        <CSVLink
          data={data.map((item) => ({
            [identifierTitle]: item[identifier] || '-',
            Status: item.status,
            'Active Plan': item.active_plan ? item.active_plan : 'No Plan',
            'User Type': item.is_pro ? 'Pro' : 'Essential',
            'Joining Date': item.joining_date ? moment(item.joining_date).format('DD-MM-YYYY') : '-',
            'Joining Time': item.joining_date ? moment(item.joining_date).format('HH:mm') : '-',
            'Expiry Date': item.expiry_date ? moment(item.expiry_date).format('DD-MM-YYYY') : '-',
            'Expiry Time': item.expiry_date ? moment(item.expiry_date).format('HH:mm') : '-',
            'Activation Date': item.activation_date ? moment(item.activation_date).format('DD-MM-YYYY') : '-',
            'Activation Time': item.activation_date ? moment(item.activation_date).format('HH:mm') : '-',
            'Termination Date': item.termination_date ? moment(item.termination_date).format('DD-MM-YYYY') : '-',
            'Termination Time': item.termination_date ? moment(item.termination_date).format('HH:mm') : '-',
            'KYC Verification Date': item.kyc_date ? moment(item.kyc_date).format('DD-MM-YYYY') : '-',
            'KYC Verification Time': item.kyc_date ? moment(item.kyc_date).format('HH:mm') : '-',
            'Renewal Date': item.renewal_date ? moment(item.renewal_date).format('DD-MM-YYYY') : '-',
            'Renewal Time': item.renewal_date ? moment(item.renewal_date).format('HH:mm') : '-',
            'Deleted At': item.deleted_at ? moment(item.deleted_at).format('DD-MM-YYYY') : '-'
          }))}
          filename={`Users_report_${moment(from).format('DD-MM-YYYY')}_${moment(
            to,
          ).format('DD-MM-YYYY')}.csv`}
          ref={csvLink}
        />
      </div>
    </div>
  );
}
